import { proxy } from 'valtio';

type Logs = {
  [key: string]: {
    start: number;
    marks: {
      [key: string]: number;
    };
  };
};

export type AllowedLabels = 'app-initialization';

export const logs = proxy<Logs>({});

const time = (label: AllowedLabels) => {
  logs[label] = {
    start: performance.now(),
    marks: {},
  };
  if (process.env.NODE_ENV === 'development') {
    console.debug(label, logs[label].start);
  }
};

const timeLog = (label: AllowedLabels, details: string) => {
  if (!logs[label]) {
    time(label);
  }

  const versionedDetails =
    details in logs[label].marks
      ? `${details}_${Object.keys(logs[label].marks).length + 1}`
      : details;

  logs[label].marks[versionedDetails] = performance.now() - logs[label].start;
  if (process.env.NODE_ENV === 'development') {
    console.debug(label, versionedDetails, logs[label].marks[versionedDetails]);
  }
};

export const perf = {
  time,
  timeLog,
};
